/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useState } from "react";
const useClientDocuments = (
  initialDocuments = {
    passport: {
      state: "initial",
      value: "",
      isLoading: false,
      preview: "",
      extension: "",
    },
    portrait: {
      state: "initial",
      value: "",
      isLoading: false,
      preview: "",
      extension: "",
    },
  }
) => {
  const [documents, setDocuments] = useState(initialDocuments);
  const handleUploadDocuments = (key, data, field = "value") => {
    if (data && data.length > 0) {
      setDocuments((prev) => {
        let value;
        if (Array.isArray(data)) {
          value = data[data.length - 1].img;
        } else if (typeof data === "string") {
          value = data;
        }
        return {
          ...prev,
          [key]: {
            ...prev[key],
            state: "success",
            [field]: value,
            isLoading: false,
          },
        };
      });
    }
  };
  return [documents, setDocuments, handleUploadDocuments];
};

export default useClientDocuments;
